@if (index == 0 && retDash === false) {
  <div class="grid">
    <a #critElem [routerLink]="'.'" [fragment]="crit"></a>
    <a #retElem [routerLink]="'.'" [fragment]="retlst"></a>
    <field-tools class="col-12 md:col-4 lg:col-4" [dataTitle]="Title" [attr.id]="retlst">
      @if (isAdmin || allowRequest) {
        <dm-fieldset-header [backGround]="false">
          <button
            class="margin"
            pButton
            type="button"
            (click)="AddRequest()"
            label="{{'Mg_Query' | translate}}"
          ></button>
        </dm-fieldset-header>
      }
        <bskfilters
            height="75vh"
            [dataBskFilters]="listRequest"
            [idRequest]="currentIdRequest"
            (dataBskFilterSelected)="onClick($event)"
        ></bskfilters>
    </field-tools>
    @if (variableList) {
      <span class="nopad col-12 md:col-4 lg:col-4">
          <field-tools
            class="col-12"
            (keydown.shift.enter)="onClickCount()"
            (keydown.control.enter)="onClickExec('', false)"
            [dataTitle]="'Filter_Crit' | translate"
            [attr.id]="crit"
            >
            <dm-fieldset-header [backGround]="false">
              <button class="margin" pButton type="button" (click)="onClickCount()" label="{{'Count' | translate}}"></button>
              <button class="margin" pButton type="button" (click)="onClickExec('', false)" label="{{'Exec' | translate}}"></button>
            </dm-fieldset-header>
            <div class="scroll-table">
              <inputvalue
                [title]="'Index_B' | translate"
                [dataVariableList]="variableList"
                [libAction]="false"
                [editorService]="editorService"
                [fromReq]="true"
              ></inputvalue>
            </div>
          </field-tools>
        <field-tools class="col-12" [dataTitle]="'Display' | translate">
          <dm-fieldset-header [backGround]="false"> </dm-fieldset-header>
          <div class="scroll-table">
            <p-listbox
              [options]="listResult"
              [(ngModel)]="selectedResults"
              [filter]="listResult.length > 10"
              optionLabel="label"
              [listStyle]="{ width: '100%' }"
              scrollHeight="30rem"
              >
              <ng-template let-result pTemplate="item">
                <div class="flex align-items-center">
                  @if (result.visibility === 1) {
                    <i
                      class="icons8-user-groups margin-right iconstyle"
                    ></i>
                  }
                  @if (result.visibility === 2) {
                    <i class="icons8-user margin-right iconstyle"></i>
                  }
                  <span class="margin-left">{{ result.label }}</span>
                </div>
              </ng-template>
            </p-listbox>
          </div>
        </field-tools>
      </span>
      <field-tools class="col-12 md:col-4 lg:col-4" [dataTitle]="'Filter_Comp' | translate">
        <dm-fieldset-header [backGround]="false"> </dm-fieldset-header>
        <div class=" flex flex-column md:flex-row column-gap-0 gap-2 grid justify-content-between">
          <div class="p-inputgroup col-6">
            <p-calendar placeholder="{{'Date_More' | translate}}" styleClass="min-w-full" class="min-w-full"
            dateFormat="dd/mm/yy" [(ngModel)]="dateBegin" [showClear]=true></p-calendar>
          </div>
          <div class="p-inputgroup col-6">
            <p-calendar placeholder="{{'Date_Less' | translate}}" styleClass="min-w-full" class="min-w-full"
            dateFormat="dd/mm/yy" [(ngModel)]="dateEnd" [showClear]=true></p-calendar>
          </div>
          <div class="p-inputgroup col-12">
            <p-dropdown [options]="formatList" [(ngModel)]="formatType" optionLabel="label" optionValue="value" styleClass="min-w-full"
            class="min-w-full" placeholder="{{'Filter_For' | translate}}" [showClear]=true></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="flex mb-1">
            <p-checkbox
              class="p-field"
              [(ngModel)]="checkFilter"
              binary="true"
              (onChange)="onChangeCkFilter($event)"
              name="checkFilter"
              inputId="Filter"
            ></p-checkbox>
            <label for="Filter" class="ml-2">{{'Filter' | translate}}</label>
          </div>
          <div class="scroll-table">
            <p-tree
              filter="true"
              styleClass="h-40rem"
              filterPlaceholder="{{'Filter' | translate}}"
              [value]="treeIndex"
              selectionMode="single"
              (onNodeSelect)="nodeSelect($event)"
              (onNodeExpand)="nodeExpand($event)"
              [emptyMessage]="'No_TreeLoad' | translate"
              >
              <ng-template let-node pTemplate="default">
                <span id={{node.key}}>
                  {{ node.label }}
                </span>
              </ng-template>
              <ng-template pTemplate="footer">
                @if (loadTree === false) {
                  <span style="font-weight: bolder;">
                    {{'TreeLoad' | translate}}
                  </span>
                }
              </ng-template>
            </p-tree>
          </div>
        </div>
      </field-tools>
    }
  </div>
}
@if (index == 1) {
  <div class="display-block">
    @if (retDash === false) {
      <span>{{'Query' | translate}} {{ currentLabelRequest }} </span>
    }
    <div class="right">
      @if (displayListResult === true) {
        <button
          class="btnsize margin-left"
          type="button" pButton
          pTooltip="{{'Return_Res' | translate}}"
          tooltipPosition="left"
          icon="pi icons8-retour" styleClass="p-button-success"
          (click)="returnList()"
        ></button>
      }
      @if (displayCriteria === true) {
        <button
          class="btnsize margin-left"
          type="button" pButton
          pTooltip="{{ retTipLib }}"
          tooltipPosition="left"
          icon="pi icons8-home" styleClass="p-button-success"
          (click)="returnCriteria()"
        ></button>
      }     
      @if (displayCriteria === true && displayListResult === false && allowFullText === true) {
        <button
          class="btnsize margin-left"
          type="button" pButton
          pTooltip={{filterState.message}}
          tooltipPosition="left"
          [ngClass]="filterState.state === true ? 'p-button-warning' : 'p-button-primary'"
          icon="pi icons8-search"
          (click)="onFilterSearch()"
        ></button>
      }
    </div>
  </div>
  <displayresult
    #dispresult
    [srchMode]="srchMode"
    [resultDisplay]="resultDisplay"
    [btnAction]="true"
    [nbDoc]="nbDoc"
    [listColumns]="listColumns"
    [infoList]="infoList"
    [currentSelectedBsk]="{}"
    [listBskVariable]="[]"
    [basketMoveAll]="[]"
    [curPage]="curPage"
    [request]="currentRequest"
    [isDesktop]="isDesktop"
    [autoDocId]="autoDocId"
    [fetchParam]="fetchParam"
    (onReturnResult)="onReturnResult($event)"
    (onAction)="onAction($event)"
    (onNextDocs)="onNextDocs()"
    >
  </displayresult>
}

<countdocs [visible]="visibleCount" [anbdoc]="nbDocCount" (onAnbdocUpdate)="onCountDoc($event)"></countdocs>

@if (displaySearch === true) {
  <filterdocs
    [visible]="displaySearch"
    (onFilter)="onClickSearch($event)"
    (onClose)="closeSearch()"
    >
  </filterdocs>
}
